import { createStore, createLogger } from 'vuex'

// import { createLogger } from 'vuex'

import acl from '@/store/acl'
import activities from '@/store/activities'
import activitiesFilter from '@/store/activitiesFilter'
import aggregators from '@/store/aggregators'
import clipboard from '@/store/clipboard'
import clipboardFileAssignment from '@/store/clipboardFileAssignment'
import company from '@/store/company'
import companyUsersListModus from '@/store/companyUsersListModus'
import currentUser from '@/store/currentUser'
import documents from '@/store/documents'
import documentsFilter from '@/store/documentsFilter'
import documentsFilterMailer from '@/store/documentsFilterMailer'
import documentsFilterModusApproval from '@/store/documentsFilterModusApproval'
import documentsFilterModusTrash from '@/store/documentsFilterModusTrash'
import documentsImport from '@/store/documentsImport'
import documentsImportFilter from '@/store/documentsImportFilter'
import documentsListModus from '@/store/documentsListModus'
import documentsNewPrefill from '@/store/documentsNewPrefill'
import download from '@/store/download'
import help from '@/store/help'
import layout from '@/store/layout'
import locationLayers from '@/store/locationLayers'
import mailer from '@/store/mailer'
import participants from '@/store/participants'
import participantsCreator from '@/store/participantsCreator'
import participantsFilter from '@/store/participantsFilter'
import participantsFilterModusTrash from '@/store/participantsFilterModusTrash'
import participantsImport from '@/store/participantsImport'
import participantsListModus from '@/store/participantsListModus'
import pfFiles from '@/store/pfFiles'
import pfFilesImport from '@/store/pfFilesImport'
import photos from '@/store/photos'
import photosFilter from '@/store/photosFilter'
import photosFilterMapView from '@/store/photosFilterMapView'
import photosFilterTrash from '@/store/photosFilterTrash'
import photosListModus from '@/store/photosListModus'
import photosNewPrefill from '@/store/photosNewPrefill'
import photosSortingModalAppendPinToPhoto from '@/store/photosSortingModalAppendPinToPhoto'
import plans from '@/store/plans'
import plansFilter from '@/store/plansFilter'
import plansFilterMailer from '@/store/plansFilterMailer'
import plansFilterModusApproval from '@/store/plansFilterModusApproval'
import plansFilterModusTrash from '@/store/plansFilterModusTrash'
import plansImport from '@/store/plansImport'
import plansImportFilter from '@/store/plansImportFilter'
import plansListModus from '@/store/plansListModus'
import plansNewPrefill from '@/store/plansNewPrefill'
import filterToServerSync from '@/store/plugins/filter-to-server-sync'
import localStorageSync from '@/store/plugins/local-storage-sync'
import printJobs from '@/store/printJobs'
import project from '@/store/project'
import projects from '@/store/projects'
import projectsFilter from '@/store/projectsFilter'
import recipientGroups from '@/store/recipientGroups'
import tasks from '@/store/tasks'
import tasksFilterDone from '@/store/tasksFilterDone'
import tasksFilterDoneMapView from '@/store/tasksFilterDoneMapView'
import tasksFilterDrafts from '@/store/tasksFilterDrafts'
import tasksFilterDraftsMapView from '@/store/tasksFilterDraftsMapView'
import tasksFilterMain from '@/store/tasksFilterMain'
import tasksFilterMainMapView from '@/store/tasksFilterMainMapView'
import tasksFilterTrash from '@/store/tasksFilterTrash'
import tasksListModus from '@/store/tasksListModus'
import tasksNewPrefill from '@/store/tasksNewPrefill'
import tasksSortingModalAppendPinToTask from '@/store/tasksSortingModalAppendPinToTask'
import textblocks from '@/store/textblocks'
import unsavedChanges from '@/store/unsavedChanges'
import vcf from '@/store/vcf'

// ATTENTION: createLogger() is responsible for a HUGE performance impact if the task list grows. So make sure to remove it, when working with big lists (or on production)
const isLoggingEnabled = process.env.NODE_ENV === 'production' && false

// only enable localStorageSync when not in backup app (file:// protocol or localTestingHostname
let isBackupApp = false

if (window.localStorage.getItem('planfred_hostname') === 'backup.localhost' || window.location.protocol === 'file:') {
  isBackupApp = true
}

const plugins = [ filterToServerSync ]

if (!isBackupApp) {
  plugins.unshift(localStorageSync)
}

if (isLoggingEnabled) {
  plugins.push(createLogger())
}

export default createStore({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    acl,
    activities,
    activitiesFilter,
    aggregators,
    clipboard,
    clipboardFileAssignment,
    company,
    companyUsersListModus,
    currentUser,
    documents,
    documentsFilter,
    documentsFilterMailer,
    documentsFilterModusApproval,
    documentsFilterModusTrash,
    documentsImport,
    documentsImportFilter,
    documentsListModus,
    documentsNewPrefill,
    download,
    layout,
    locationLayers,
    mailer,
    participants,
    participantsCreator,
    participantsFilter,
    participantsFilterModusTrash,
    participantsImport,
    participantsListModus,
    plans,
    plansFilter,
    plansFilterMailer,
    plansFilterModusApproval,
    plansFilterModusTrash,
    plansImport,
    plansImportFilter,
    plansListModus,
    plansNewPrefill,
    printJobs,
    project,
    projects,
    projectsFilter,
    recipientGroups,
    tasks,
    tasksNewPrefill,
    tasksFilterDone,
    tasksFilterDrafts,
    tasksFilterMain,
    tasksFilterDoneMapView,
    tasksFilterDraftsMapView,
    tasksFilterMainMapView,
    tasksFilterTrash,
    tasksListModus,
    textblocks,
    unsavedChanges,
    tasksSortingModalAppendPinToTask,
    help,
    pfFiles,
    pfFilesImport,
    photos,
    photosListModus,
    photosNewPrefill,
    photosFilter,
    photosFilterMapView,
    photosFilterTrash,
    photosSortingModalAppendPinToPhoto,
    vcf,
  },

  plugins,
})
